import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000' });

export default function AcceptInvite({ token, user, onDone }) {
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) return;
    if (!user) {
      setStatus('needLogin');
      return;
    }
    acceptInvite();
  }, [token, user]);

  const acceptInvite = async () => {
    try {
      const authToken = localStorage.getItem('cms_token');
      const res = await API.post('/api/projects/invite/accept', { token }, {
        headers: { Authorization: `Bearer ${authToken}` }
      });
      setMessage(`You joined "${res.data.project}" as ${res.data.role}!`);
      setStatus('success');
    } catch(e) {
      setMessage(e.response?.data?.error || 'Invalid or expired invite link');
      setStatus('error');
    }
  };

  return (
    <div style={{minHeight:'100vh',background:'#0f0f0f',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'IBM Plex Sans, sans-serif'}}>
      <div style={{background:'#181818',border:'1px solid #2a2a2a',borderRadius:12,padding:32,width:380,textAlign:'center'}}>
        <div style={{fontSize:32,marginBottom:16}}>
          {status === 'loading' && '⏳'}
          {status === 'success' && '✅'}
          {status === 'error' && '❌'}
          {status === 'needLogin' && '🔐'}
        </div>
        <div style={{fontSize:16,fontWeight:600,color:'#e8e8e8',marginBottom:8}}>
          {status === 'loading' && 'Accepting invite...'}
          {status === 'success' && 'Joined successfully!'}
          {status === 'error' && 'Invite failed'}
          {status === 'needLogin' && 'Login required'}
        </div>
        <div style={{fontSize:13,color:'#888',marginBottom:24}}>{message}</div>
        {status === 'needLogin' && <p style={{fontSize:13,color:'#888'}}>Please log in first, then visit this link again.</p>}
        <button onClick={onDone} style={{padding:'9px 24px',background:'#6366f1',border:'none',borderRadius:6,color:'#fff',fontSize:13,cursor:'pointer',fontFamily:'IBM Plex Sans, sans-serif'}}>
          {status === 'success' ? 'Go to Dashboard' : 'Back to Dashboard'}
        </button>
      </div>
    </div>
  );
}
